import { t } from "@ebay/i18n-ebay";
import type { ErrorModule, InstallmentDisplay } from "../../../../../interface";
import { UK, US } from "../../../../../common/constants";
export class Input {
  site?: string;
  installmentOffers!: Array<InstallmentDisplay>;
  error?: ErrorModule;
  loading?: boolean;
}

<div class="table-container">
  <if(input.loading)>
    <div id="calc-throbber">
      <img id="calcThrobber" alt="Loading Image" src="./imgLoading_30x30.gif">
    </div>
  </if>

  <table class="calc-table-width">
    <caption class="clipped">
      Table 1 - Estimate amounts with Paypal credit
    </caption>
    <if(input.error?.name)>
      <tbody>
        <tr>
          <td style="word-spacing:-1px;border: 0;padding-left: 10px;line-height: 20px;">
            <div role="status" aria-live="polite">
              <span>${input.error.message}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </if>
    <else-if(input.installmentOffers?.length === 0)>
      <tbody>
        <tr>
          <td style="word-spacing:2px;border: 0;">
            <div role="status" aria-live="polite">
              <span>${t("calculator-table/index", `ERROR_${input.site}`)}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </else-if>
    <else>
      <if(input.site === UK)>
        <thead>
          <tr>
            <th class="calc-monthly-payment">
              Monthly Payment
            </th>
            <th class="calc-months">
              No. of Months
            </th>
            <th class="calc-apr">
              Total amount
            </th>
            <th class="calc-min-purchase">
              Minimum Purchase
            </th>
            <th class="calc-interest">
              Interest p.a.
            </th>
          </tr>
        </thead>
        <tbody>
          <for|model: InstallmentDisplay, index| of=input.installmentOffers>
            <tr>
              <td>${model.monthlyPayment}</td>
              <td>${model.months}</td>
              <td>${model.totalAmountWithInterest}</td>
              <td>${model.minPurchase}</td>
              <td>${model.apr}</td>
            </tr>
          </for>
        </tbody>
      </if>
      <else-if(input.site === US)>
        <thead>
          <tr>
            <th class="calc-monthly-payment">
              Monthly Payment
            </th>
            <th class="calc-months">
              Months
            </th>
            <th class="calc-min-purchase">
              Min Purchase
            </th>
            <th class="calc-interest">
              Total w/ interest
            </th>
            <th class="calc-apr">
              APR
            </th>
          </tr>
        </thead>
        <tbody>
          <for|model: InstallmentDisplay, index| of=input.installmentOffers>
            <tr>
              <td>${model.monthlyPayment}</td>
              <td>${model.months}</td>
              <td>${model.minPurchase}</td>
              <td>${model.totalAmountWithInterest}</td>
              <td>${model.apr}</td>
            </tr>
          </for>
        </tbody>
      </else-if>
    </else>
  </table>
</div>
